import { useMemo } from "react";
import { Show } from "shared/components";
import { BenefitsStatementItem } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified/benefits-statement";
import { DocumentCard } from "views/applications-id-report/slices/IncomeReportSlice/components/DocumentCard";
import { getBenefitsStatementReasonCodes } from "./utils";
import { ContentTitle } from "views/applications-id-report/components/ContentTitle";
import { KeyValue } from "views/applications-id-report/components/KeyValue";
import { formatDate } from "views/applications-id-report/utils";

export const ExpandedTableRow = ({
  benefitsItem
}: {
  benefitsItem: BenefitsStatementItem;
}) => {
  const hasAsset = Boolean(benefitsItem.income_source_data?.asset?.asset);
  const reasonCodes = useMemo(
    () => getBenefitsStatementReasonCodes(benefitsItem),
    [benefitsItem]
  );

  return (
    <div className="px-6 py-8 bg-background-900">
      <Show if={hasAsset}>
        <DocumentCard
          score={benefitsItem.income_source_data?.raw_data?.trust_score ?? 0}
          asset={benefitsItem.income_source_data?.asset?.asset}
          reasonCodes={reasonCodes}
          ignorePrint
        />
        <div className="py-2" aria-hidden />
      </Show>

      <ContentTitle
        title="Government benefit letter details"
        contentClassName="space-y-2"
      >
        <KeyValue
          label="Name"
          value={benefitsItem.data?.benefits_statement.name}
        />
        <KeyValue
          label="Address"
          value={benefitsItem.data?.benefits_statement.address}
        />
        <KeyValue
          label="Document date"
          value={formatDate(benefitsItem.data?.benefits_statement.date)}
        />
      </ContentTitle>
    </div>
  );
};
